<template>
  <ul class="recommend border-radius-8" :style="myStyle" v-if="recommendList.length">
    <li v-for="(item, index) in recommendList" :class="['recommend-item', index>(recommendList.length-5)?'row-2':'']" :key="item.id" @click="clickIcon(item.id)" :style="itemStyle">
      <router-link :to="item.href" class="item-wrap" >
        <lazy-img :width="`${imgWidth}px`" :height="`${imgWidth}px`" background="#fff" defaultImgWidth="28px" :src="item.imgUrl" ></lazy-img>
        <div class="item-title">{{item.title}}</div>
      </router-link>
    </li>
  </ul>
</template>

<script>
  import lazyImg from './lazy-img'

  export default {
    props: {
      recommendList: {
        type: Array,
        default: [],
      },
      imgWidth: {
        type: [Number, String],
        default: 45,
      },
      myStyle: [String],
      itemStyle: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    methods: {
      clickIcon(id) {
        this.$emit('click-icon', id)
      },
    },
    name: 'recommend',
    data() {
      return {
      }
    },
    components: {
      'lazy-img': lazyImg,
    },
  }
</script>

<style lang="less" scoped>
  .recommend {
    width: 100%;
    padding: 15px 0px 15px;
    margin: 0 0;
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    list-style: none;
    background-color: #ffffff;
    /deep/ .lazy-img .lazy-img-wrap .target-img {
      border-radius: 0px !important;
    }
    li {
      display: block;
    }
    .recommend-item {
      width: 25%;
      margin-bottom: 23px;
      .item-wrap {
        .lazy-img {
          margin: 0 auto 5px;
        }
        .item-title {
          font-size: 13px;
          width: 100%;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #2E2F30;
        }
      }
    }
    .row-2 {
      margin-bottom: 0px;
    }
  }
</style>
